import React from 'react'

export default function empCheckinDetails() {
  return (
    <div>empCheckinDetails</div>
  )
}
